import React, { createContext, useContext, useEffect, useState } from 'react';

const MODULES = {
  agri:       { name:'ZevaZeva', icon:'', label:'Crops' },
  nursery:    { name:'Nursery',     icon:'', label:'Nursery' },
  ecommerce:  { name:'Shop',        icon:'🛒', label:'Shop' },
  land:       { name:'Land',        icon:'🏡', label:'Land' },
  equipment:  { name:'Equipment',   icon:'🚜', label:'Equipment' },
  organic:    { name:'Organic',     icon:'', label:'Organic' },
};

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  const [module, setModule] = useState(() => localStorage.getItem('agri_module') || 'agri');

  useEffect(() => {
    document.body.setAttribute('data-module', module);
    localStorage.setItem('agri_module', module);
  }, [module]);

  return (
    <ThemeContext.Provider value={{ module, setModule, MODULES }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
